import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { useIntl } from "react-intl";
import GoogleMapsButton from "../../components/GoogleMapsButton";
import Icon from "../../components/Icon";
import Widget from "../../components/Widget";
import Image from "../../overrides/venia-ui/components/Image";

// Styles
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./storeDetails.module.scss";

//Assets
import point from "../../assets/images/pickup-point.png";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import Button from "@overrides_venia/venia-ui/components/Button/button";
import { useHistory } from "@magento/venia-ui/lib/drivers";
import it from "date-fns/locale/it";
import { addDays, format, startOfWeek } from "date-fns";
var StoreDetails = _ref => {
  var _store$address, _store$address2;
  var {
    store,
    showCta = true
  } = _ref;
  var {
    formatMessage
  } = useIntl();
  var {
    isMobile
  } = useWindowSize();
  var history = useHistory();
  var classes = mergeClasses(defaultClasses);
  var firstDOW = startOfWeek(new Date(), {
    weekStartsOn: 1
  });
  var shortWeekDaysArray = Array.from(Array(7)).map((e, i) => format(addDays(firstDOW, i), "EEEE", {
    locale: it
  }));
  var storeHoursList = Object.keys(store.store_hours).map(dow => {
    return {
      hours: _objectSpread({}, store.store_hours[dow]),
      dow: dow
    };
  }).map((x, i) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "uk-flex uk-flex-between uk-margin-small-bottom",
      key: i
    }, /*#__PURE__*/React.createElement("span", {
      className: "uk-margin-large-right"
    }, shortWeekDaysArray[i]), /*#__PURE__*/React.createElement("div", {
      className: "uk-flex"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "icon-shipping",
      color: "black"
    }), /*#__PURE__*/React.createElement("div", {
      className: "uk-flex uk-flex-column uk-margin-small-left"
    }, Object.values(x.hours).map(interval => /*#__PURE__*/React.createElement("span", null, interval.open, " - ", interval.close)))));
  });
  var storeHours = /*#__PURE__*/React.createElement("div", {
    className: "store-hours uk-box-shadow-medium uk-background-creamer uk-flex ".concat(classes.hours),
    style: !isMobile ? {
      marginRight: "auto",
      marginLeft: "auto",
      minWidth: "30%"
    } : {}
  }, store.ls_store_id ? /*#__PURE__*/React.createElement("div", {
    className: "restaurant-hours ".concat(classes.restaurant)
  }, storeHoursList) : null);
  var position = (_store$address = store.address) !== null && _store$address !== void 0 && _store$address.address1 ? "Miscusi , " + store.address.address1 + "," + store.address.city + "," + store.address.post_code : "Miscusi";
  var maps = /*#__PURE__*/React.createElement("div", {
    className: "uk-margin-small-left uk-margin-small-right uk-margin-medium-top"
  }, /*#__PURE__*/React.createElement(GoogleMapsButton, {
    link: "https://maps.google.com/?q=".concat(position),
    onlyTakeaway: store.special_restaurant_closing == 1 ? true : false
  }));
  var content = /*#__PURE__*/React.createElement("div", {
    className: "content ".concat(classes.content, " uk-flex uk-flex-column")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.image)
  }, /*#__PURE__*/React.createElement(Image, {
    alt: store.frontend_name,
    src: isMobile ? store.store_preview_image_mobile ? store.store_preview_image_mobile : point : store.store_preview_image_desktop ? store.store_preview_image_desktop : store.store_preview_image_mobile,
    height: "84",
    width: "auto",
    displayPlaceholder: false
  })), store.frontend_name ? /*#__PURE__*/React.createElement("h1", {
    className: "uk-text-uppercase uk-text-center store-name"
  }, store.frontend_name) : null, (_store$address2 = store.address) !== null && _store$address2 !== void 0 && _store$address2.address1 ? /*#__PURE__*/React.createElement("div", {
    className: "store-address uk-text-center"
  }, store.address.address1) : null, storeHours, /*#__PURE__*/React.createElement("div", {
    className: "uk-fixed uk-margin-small uk-grid uk-grid-small uk-child-width-expand",
    style: !isMobile ? {
      maxWidth: "700px",
      marginLeft: "auto",
      marginRight: "auto"
    } : {}
  }, showCta && store.isPreorderActive ? /*#__PURE__*/React.createElement(Button, {
    color: "miscusi_red",
    extraClass: "uk-box-shadow-medium uk-margin-xsmall-right",
    type: "button",
    onClick: () => {
      history.push(formatMessage({
        id: "url.key.order.from.restaurant"
      }) + "/" + store.ls_store_id);
    }
  }, formatMessage({
    id: "button.order"
  })) : null, showCta && store.isReservationActive ? /*#__PURE__*/React.createElement(Button, {
    color: "dark-green",
    extraClass: "uk-box-shadow-medium uk-margin-xsmall-left",
    type: "button",
    onClick: () => {
      history.push(formatMessage({
        id: "url.key.book.a.table.from.restaurant"
      }) + "/" + store.ls_store_id);
    }
  }, formatMessage({
    id: "button.bookatable"
  })) : null), maps, store ? store.widgets.map((widget, i) => /*#__PURE__*/React.createElement(Widget, _extends({
    key: i
  }, widget))) : null);
  return /*#__PURE__*/React.createElement("div", {
    className: "page-store-details ".concat(classes.storeDetails)
  }, content);
};
export default StoreDetails;